module.exports = "<footer class=sb-page-footer> <div class=container> <div class=row> <div class=col-xs-12> <h4 translate>FOOTER.SUPPORT</h4> </div> </div> <div class=row> <div class=col-md-2> <a href=tel:+46>+46 (0)454 30 83 00</a> </div> <div class=col-md-10> <a href=mailto:info@scanbox.se>info@scanbox.se</a> </div> </div> </div> </footer> <div class=sb-page-footer-copy> <div class=container> <div class=row> <div class=col-xs-12> <span class=pull-right translate>FOOTER.COPYRIGHT</span> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/page-footer/page-footer.html
// module id = 215
// module chunks = 0